module.exports = __webpack_public_path__ + "img/all_artworks.5fb5df7e.png";